module.exports = __webpack_public_path__ + "static/media/audio_wave.798e08f0.gif";